import React from 'react';
import { Backdrop, CircularProgress, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface LanguageLoaderProps {
  isLoading?: boolean;
  message?: string;
}

/**
 * 语言加载状态组件
 * 在语言资源加载期间显示加载状态
 */
export const LanguageLoader: React.FC<LanguageLoaderProps> = ({ 
  isLoading = false, 
  message 
}) => {
  const { t, ready } = useTranslation();
  
  // 如果i18n已经就绪，则不显示加载状态
  if (ready && !isLoading) {
    return null;
  }

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(4px)',
      }}
      open={true}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" component="div">
          {message || t('loadingLanguage')}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default LanguageLoader;